import { Field, Formik, useFormikContext } from "formik";
import "./EditSchools.scss";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeEvent, useRef, useState, useEffect } from "react";
import * as yup from "yup";
import moment from "moment";
import {
  ADD_SCHOOLS,
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
} from "../../../../Utilities/Constants/Constants";
import {
  ADD_SCHOOLS_ERROR_MESSAGES,
  ERROR_MESSAGES,
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../Utilities/Constants/Validations";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import {
  numberOnlyWithDecimal,
  numberOnly,
  validateEnglish,
  uploadFileToS3,
  S3DataGetApi,
} from "../../../../Services/Helpers/Helper";
import { format } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import backButton from "../../../../../Assets/schools/back_button.svg";
import eyeIcon from "../../../../../Assets/schools/eye.svg";
import uploadFile from "../../../../../Assets/schools/upload.svg";
import upload_image from "../../../../../Assets/schools/upload_image.svg";
import close from "../../../../../Assets/schools/close.svg";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";

const EditSchools = () => {
  const uploadSchoolImages = useRef<HTMLInputElement | null>(API_RESPONSE.NULL);
  const dsibDocs = useRef<HTMLInputElement | null>(API_RESPONSE.NULL);
  const formikRef = useRef<any>();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const [schoolImages, setSchoolImages]: any = useState([]);
  const [dsibDoc, setDsibDoc]: any = useState("");
  const [dsibDocName, setDsibDocName]: any = useState("");

  /* Translation hook**/
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  /* Navigatoin hook**/
  const navigate = useNavigate();
  const [validNumber, setValidNumber] = useState(API_RESPONSE.TRUE);
  const { id } = useParams();
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  /* Get school detail function call at initial */
  useEffect(() => {
    getSchoolDetail();
  }, []);

  /* Initializing schools data */
  const [schoolsData, setSchoolsData] = useState({
    [ADD_SCHOOLS.SCHOOL_NAME]: "",
    [ADD_SCHOOLS.FOUNDED_YEAR]: "",
    [ADD_SCHOOLS.LOCATION]: "",
    [ADD_SCHOOLS.CURRICULUM]: "",
    [ADD_SCHOOLS.SCHOOL_IMAGES]: "",
    [ADD_SCHOOLS.WEBLINK_OF_SCHOOL]: "",
    [ADD_SCHOOLS.EMAIL]: "",
    [ADD_SCHOOLS.PHONE_NUMBER]: "",
    [ADD_SCHOOLS.PRINCIPAL]: "",
    [ADD_SCHOOLS.GRADE_YEAR]: "",
    [ADD_SCHOOLS.TUITION_FEES]: "",
    [ADD_SCHOOLS.OPTIONAL_SERVICE_FEES]: "",
    [ADD_SCHOOLS.ENROLLMENT_FEES]: "",
    [ADD_SCHOOLS.RE_ENROLLMENT_FEES]: "",
    [ADD_SCHOOLS.APPLICATION_FEES]: "",
    [ADD_SCHOOLS.TOTAL_FEES]: "",
    [ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES]: "",
    [ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR]: "",
    [ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR]: "",
    [ADD_SCHOOLS.WINTER_BREAK_START_DATE]: "",
    [ADD_SCHOOLS.WINTER_BREAK_END_DATE]: "",
    [ADD_SCHOOLS.SPRING_BREAK_START_DATE]: "",
    [ADD_SCHOOLS.SPRING_BREAK_END_DATE]: "",
    [ADD_SCHOOLS.SUMMER_BREAK_START_DATE]: "",
    [ADD_SCHOOLS.SUMMER_BREAK_END_DATE]: "",
    [ADD_SCHOOLS.OTHER_HOLIDAYS]: "",
    [ADD_SCHOOLS.PUBLIC_HOLIDAYS]: "",
    [ADD_SCHOOLS.DSIB_INSPECTION_REPORT]: "",
    [ADD_SCHOOLS.DSIB_RATING]: "",
  });

  /* Yup validation schema */
  const loginValidationSchema = yup.object({
    [ADD_SCHOOLS.SCHOOL_NAME]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.SCHOOL_NAME_REQUIRED),
    [ADD_SCHOOLS.FOUNDED_YEAR]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.FOUNDED_YEAR_REQUIRED),
    [ADD_SCHOOLS.LOCATION]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.LOCATION_REQUIRED),
    [ADD_SCHOOLS.CURRICULUM]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.CURRICULUM_REQUIRED),
    [ADD_SCHOOLS.SCHOOL_IMAGES]: yup
      .array()
      .typeError("")
      .min(1, ADD_SCHOOLS_ERROR_MESSAGES.SCHOOL_IMAGES_REQUIRED),
    [ADD_SCHOOLS.WEBLINK_OF_SCHOOL]: yup
      .string()
      /* .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        'Enter correct url!'
    ) */
      // .matches(REGEX.URL_VALIDATION, "Enter correct url!")
      .required(ADD_SCHOOLS_ERROR_MESSAGES.WEBLINK_OF_SCHOOL_REQUIRED),
    [ADD_SCHOOLS.EMAIL]: yup
      .string()
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .required(ADD_SCHOOLS_ERROR_MESSAGES.EMAIL_REQUIRED),
    // .email(ADD_SCHOOLS_ERROR_MESSAGES.INVALID_EMAIL),
    [ADD_SCHOOLS.PHONE_NUMBER]: yup
      .string()
      .required(ERROR_MESSAGES.PHONE_NUMBER),
    [ADD_SCHOOLS.PRINCIPAL]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.PRINCIPAL_REQUIRED),
    [ADD_SCHOOLS.TUITION_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.TUITION_FEES_REQUIRED),
    [ADD_SCHOOLS.OPTIONAL_SERVICE_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.OPTIONAL_SERVICE_FEES_REQUIRED),
    [ADD_SCHOOLS.ENROLLMENT_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.ENROLLMENT_FEES_REQUIRED),
    [ADD_SCHOOLS.RE_ENROLLMENT_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.RE_ENROLLMENT_FEES_REQUIRED),
    [ADD_SCHOOLS.APPLICATION_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.APPLICATION_FEES_REQUIRED),
    [ADD_SCHOOLS.TOTAL_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.TOTAL_FEES_REQUIRED),
    [ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES]: yup
      .number()
      .typeError(ADD_SCHOOLS_ERROR_MESSAGES.ONLY_NUMBERS),
    // .required(ADD_SCHOOLS_ERROR_MESSAGES.DISCOUNT_ON_TUITION_FEES_REQUIRED),

    [ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR]: yup
      .date()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.START_OF_THE_ACADEMIC_YEAR_REQUIRED),

    [ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR]: yup
      .date()
      .test(
        ADD_SCHOOLS_ERROR_MESSAGES.TEST_SUPERIOR,
        ADD_SCHOOLS_ERROR_MESSAGES.END_DATE_GREATER,
        function (value: any) {
          const ref: any = yup.ref(ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR);
          const end_date: any = yup.ref(ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR);
          if (new Date(this.resolve(end_date)) >= new Date(this.resolve(ref))) {
            return API_RESPONSE.TRUE;
          } else {
            return API_RESPONSE.FALSE;
          }
        }
      )
      .required(ADD_SCHOOLS_ERROR_MESSAGES.END_OF_THE_ACADEMIC_YEAR_REQUIRED),

    [ADD_SCHOOLS.WINTER_BREAK_START_DATE]: yup
      .date()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.WINTER_BREAK_START_DATE_REQUIRED),
    [ADD_SCHOOLS.WINTER_BREAK_END_DATE]: yup
      .date()
      .test(
        ADD_SCHOOLS_ERROR_MESSAGES.TEST_SUPERIOR,
        ADD_SCHOOLS_ERROR_MESSAGES.WINTER_END_DATE_GREATER,
        function (value: any) {
          const ref: any = yup.ref(ADD_SCHOOLS.WINTER_BREAK_START_DATE);
          const end_date: any = yup.ref(ADD_SCHOOLS.WINTER_BREAK_END_DATE);
          if (new Date(this.resolve(end_date)) >= new Date(this.resolve(ref))) {
            return API_RESPONSE.TRUE;
          } else {
            return API_RESPONSE.FALSE;
          }
        }
      )
      .required(ADD_SCHOOLS_ERROR_MESSAGES.WINTER_BREAK_END_DATE_REQUIRED),
    [ADD_SCHOOLS.SPRING_BREAK_START_DATE]: yup
      .date()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.SPRING_BREAK_START_DATE_REQUIRED),
    [ADD_SCHOOLS.SPRING_BREAK_END_DATE]: yup
      .date()
      .test(
        ADD_SCHOOLS_ERROR_MESSAGES.TEST_SUPERIOR,
        ADD_SCHOOLS_ERROR_MESSAGES.SPRING_END_DATE_GREATER,
        function (value: any) {
          const ref: any = yup.ref(ADD_SCHOOLS.SPRING_BREAK_START_DATE);
          const end_date: any = yup.ref(ADD_SCHOOLS.SPRING_BREAK_END_DATE);
          if (new Date(this.resolve(end_date)) >= new Date(this.resolve(ref))) {
            return API_RESPONSE.TRUE;
          } else {
            return API_RESPONSE.FALSE;
          }
        }
      )
      .required(ADD_SCHOOLS_ERROR_MESSAGES.SPRING_BREAK_END_DATE_REQUIRED),
    [ADD_SCHOOLS.SUMMER_BREAK_START_DATE]: yup
      .date()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.SUMMER_BREAK_START_DATE_REQUIRED),
    [ADD_SCHOOLS.SUMMER_BREAK_END_DATE]: yup
      .date()
      .test(
        ADD_SCHOOLS_ERROR_MESSAGES.TEST_SUPERIOR,
        ADD_SCHOOLS_ERROR_MESSAGES.SUMMER_END_DATE_GREATER,
        function (value: any) {
          const ref: any = yup.ref(ADD_SCHOOLS.SUMMER_BREAK_START_DATE);
          const end_date: any = yup.ref(ADD_SCHOOLS.SUMMER_BREAK_END_DATE);
          if (new Date(this.resolve(end_date)) >= new Date(this.resolve(ref))) {
            return true;
          } else {
            return false;
          }
        }
      )
      .required(ADD_SCHOOLS_ERROR_MESSAGES.SUMMER_BREAK_END_DATE_REQUIRED),
    [ADD_SCHOOLS.OTHER_HOLIDAYS]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.OTHER_HOLIDAYS_REQUIRED),
    [ADD_SCHOOLS.PUBLIC_HOLIDAYS]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.PUBLIC_HOLIDAYS_REQUIRED),
    [ADD_SCHOOLS.DSIB_INSPECTION_REPORT]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.DSIB_INSPECTION_REPORT_REQUIRED),
    [ADD_SCHOOLS.DSIB_RATING]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.DSIB_RATING_REQUIRED),
  });

  /* Get school detail API call */
  const getSchoolDetail = () => {
    axiosInstance
      .get(API_END_POINTS.SCHOOL_BULK_UPLOAD + `?${STORAGE_KEYS.ID}=` + id)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setSchoolImages(response.data.result.data.images);
          setDsibDoc(response.data.result.data.dsib_inspection_report);
          setSchoolDetail(response.data.result.data);
        }
      });
  };

  /* Formatting dates as per payload requirement */
  const formatDate = (payload: any) => {
    payload[ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR] = format(
      new Date(payload[ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR] = format(
      new Date(payload[ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.WINTER_BREAK_START_DATE] = format(
      new Date(payload[ADD_SCHOOLS.WINTER_BREAK_START_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.WINTER_BREAK_END_DATE] = format(
      new Date(payload[ADD_SCHOOLS.WINTER_BREAK_END_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.SPRING_BREAK_START_DATE] = format(
      new Date(payload[ADD_SCHOOLS.SPRING_BREAK_START_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.SPRING_BREAK_END_DATE] = format(
      new Date(payload[ADD_SCHOOLS.SPRING_BREAK_END_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.SUMMER_BREAK_START_DATE] = format(
      new Date(payload[ADD_SCHOOLS.SPRING_BREAK_START_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    payload[ADD_SCHOOLS.SUMMER_BREAK_END_DATE] = format(
      new Date(payload[ADD_SCHOOLS.SUMMER_BREAK_END_DATE]),
      COMMON_CONSTANTS.YMD_FORMAT
    )
    return payload;
  };

  /* Update school detail API */
  const updateSchoolDetail = (payload: any) => {

    let addSchoolPayload = formatDate(payload);
    addSchoolPayload.grades = [
      {
        id: 1,
        grade: "a",
        tuition_fee: "1000",
        optional_service_fee: "200",
        enrollment_fee: "40",
        re_enrollment_fee: "90",
        application_fee: "30",
        total_fee: "10",
        discount_tuition_fee: "20",
      },
      {
        id: 2,
        grade: "b",
        tuition_fee: "2000",
        optional_service_fee: "200",
        enrollment_fee: "40",
        re_enrollment_fee: "90",
        application_fee: "30",
        total_fee: "10",
        discount_tuition_fee: "20",
      },
    ];

    addSchoolPayload.images = schoolImages;
    addSchoolPayload.dsib_inspection_report = dsibDoc;
    addSchoolPayload.rating = "Good";
    addSchoolPayload.ranking = NUMBER_CONSTANTS.TWO;
    axiosInstance
      .put(API_END_POINTS.SCHOOL_BULK_UPLOAD + "?id=" + id, addSchoolPayload)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          navigate(ROUTES.MANAGE_SCHOOLS);
        }
      });
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return;
    }
    let formData = new FormData();
    formData.append("csv", event.target.files[NUMBER_CONSTANTS.ZERO]);
    axiosInstance
      .post(API_END_POINTS.SCHOOL_BULK_UPLOAD, formData)
      .then((bulkUploadResponse: any) => {
        toast.success(bulkUploadResponse.data.message, TOASTER_CONFIGS);
      });
  };

  const currentYear = new Date().getFullYear();

  const shouldDisableYear = (year: any) => {
    return new Date(year).getFullYear() > currentYear;
  };

  useEffect(() => {
    formikRef.current.setFieldValue(ADD_SCHOOLS.SCHOOL_IMAGES, schoolImages);
  }, [schoolImages]);

  const handleChange = async (event: any) => {
    // if (event.target.files[0].type.split('/')[0] === 'image') {
    try {
      if (schoolImages.length + event.target.files.length <= NUMBER_CONSTANTS.TEN) {
        for (let i = NUMBER_CONSTANTS.ZERO; i < event.target.files.length; i++) {
          const uploadedImage = await S3DataGetApi(event);
          // schoolImages.length <=5  ?
          setTimeout(() => {
            setSchoolImages((schoolImages: any) => [
              ...schoolImages,
              uploadedImage,
            ]);
          }, 0);
        }
      } else {
        toast.error(ERROR_MESSAGES.MAX_TEN_IMAGE);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }

    // }
  };

  // const { setFieldValue } = useFormikContext();
  const onUploadDsibRecord = async (event: any) => {
    try {
      if (event.target.files[NUMBER_CONSTANTS.ZERO].type.split("/")[NUMBER_CONSTANTS.ONE] === COMMON_CONSTANTS.PDF) {
        const uploadedImage = await S3DataGetApi(event);
        setDsibDocName(event.target.files[NUMBER_CONSTANTS.ZERO].name);
        formikRef.current.setFieldValue(
          ADD_SCHOOLS.DSIB_INSPECTION_REPORT,
          uploadedImage
        );
        setDsibDoc(uploadedImage);
      } else {
        toast.error(REGISTRATION_ERRORS.PDF_FORMAT);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  /* Delete tag from taglist */
  const handleDelete = (i: any) => () => {
    setSchoolImages(
      schoolImages.filter((item: any, index: any) => index !== i)
    );
  };

  const setSchoolDetail = (data: any) => {
    setDsibDocName(
      data.dsib_inspection_report
        ? data.dsib_inspection_report.split("/").slice(NUMBER_CONSTANTS.MINUS_ONE)
        : ""
    );
    setSchoolImages(data.images);
    // setValidNumber(isValidPhoneNumber(data?.phone_number));
    setSchoolsData({
      [ADD_SCHOOLS.SCHOOL_NAME]: data.school_name,
      [ADD_SCHOOLS.FOUNDED_YEAR]: data.founded_year,
      [ADD_SCHOOLS.LOCATION]: data.address,
      [ADD_SCHOOLS.CURRICULUM]: data.curriculam,
      [ADD_SCHOOLS.SCHOOL_IMAGES]: data.images,
      [ADD_SCHOOLS.WEBLINK_OF_SCHOOL]: data.web_link,
      [ADD_SCHOOLS.EMAIL]: data.email,
      [ADD_SCHOOLS.PHONE_NUMBER]: data?.phone_number,
      [ADD_SCHOOLS.PRINCIPAL]: data.principal,
      [ADD_SCHOOLS.TUITION_FEES]: "",
      [ADD_SCHOOLS.OPTIONAL_SERVICE_FEES]: "",
      [ADD_SCHOOLS.ENROLLMENT_FEES]: "",
      [ADD_SCHOOLS.RE_ENROLLMENT_FEES]: "",
      [ADD_SCHOOLS.APPLICATION_FEES]: "",
      [ADD_SCHOOLS.TOTAL_FEES]: "",
      [ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES]: "",
      [ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR]: data.academic_year_start,
      [ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR]: data.academic_year_end,
      [ADD_SCHOOLS.WINTER_BREAK_START_DATE]: data.winter_break_start,
      [ADD_SCHOOLS.WINTER_BREAK_END_DATE]: data.winter_break_end,
      [ADD_SCHOOLS.SPRING_BREAK_START_DATE]: data.spring_break_start,
      [ADD_SCHOOLS.SPRING_BREAK_END_DATE]: data.spring_break_end,
      [ADD_SCHOOLS.SUMMER_BREAK_START_DATE]: data.summer_break_start,
      [ADD_SCHOOLS.SUMMER_BREAK_END_DATE]: data.summer_break_end,
      [ADD_SCHOOLS.OTHER_HOLIDAYS]: data.other_holidays,
      [ADD_SCHOOLS.PUBLIC_HOLIDAYS]: data.public_holidays,
      [ADD_SCHOOLS.DSIB_INSPECTION_REPORT]: data.dsib_inspection_report,
      [ADD_SCHOOLS.DSIB_RATING]: data.dsip_rating ? data.dsip_rating : "",
      [ADD_SCHOOLS.RATING]: `${data.rating}`,
      [ADD_SCHOOLS.RANKING]: `${data.ranking}`,
    });
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={schoolsData}
        validationSchema={loginValidationSchema}
        onSubmit={(values, actions) => {
          updateSchoolDetail(values);
        }}
        enableReinitialize={true}
      >
        {(formik) => (
          <div
            className="school_fields_container"
          // onSubmit={formik.handleSubmit}
          >
            <div className="arrow-wrap">
              <img
                className="school-back"
                onClick={() => {
                  navigate(ROUTES.MANAGE_SCHOOLS);
                }}
                src={backButton}
                alt="Learn and Play"
              />
              <h5 className="name-title">{t("Edit School")}</h5>
            </div>
            <div className="row school-row-wrap">
              <div id="card-title">{t("Basic Details")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("School Name")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("School Name")}
                      name={ADD_SCHOOLS.SCHOOL_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.SCHOOL_NAME] &&
                        formik.errors[ADD_SCHOOLS.SCHOOL_NAME] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.SCHOOL_NAME]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Founded Year")}</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        className="date_pickers"
                        label={t("Founded Year")}
                        shouldDisableYear={shouldDisableYear}
                        openTo="year"
                        views={["year"]}
                        value={
                          new Date(formik.values[ADD_SCHOOLS.FOUNDED_YEAR])
                        }
                        onChange={(date) => {
                          const formattedDate = date
                            ? format(date, "yyyy")
                            : "";
                          formik.setFieldValue(
                            ADD_SCHOOLS.FOUNDED_YEAR,
                            formattedDate
                          );
                        }}
                      /* onChange={(foundedYear: any) =>
                      formik.setFieldValue(
                        ADD_SCHOOLS.FOUNDED_YEAR,
                        foundedYear
                      )
                    } */
                      />
                    </LocalizationProvider>
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.FOUNDED_YEAR] &&
                        formik.errors[ADD_SCHOOLS.FOUNDED_YEAR] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.FOUNDED_YEAR]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Name of the Principal")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Name of the Principal")}
                      name={ADD_SCHOOLS.PRINCIPAL}
                      onKeyPress={(event: any) => {
                        validateEnglish(event);
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.PRINCIPAL] &&
                        formik.errors[ADD_SCHOOLS.PRINCIPAL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.PRINCIPAL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Curriculum")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Curriculum")}
                      name={ADD_SCHOOLS.CURRICULUM}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.CURRICULUM] &&
                        formik.errors[ADD_SCHOOLS.CURRICULUM] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.CURRICULUM]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Email")}</label>
                    <Field
                      disabled
                      className="form_inputs disabled-input"
                      placeholder={t("Email")}
                      name={ADD_SCHOOLS.EMAIL}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.EMAIL] &&
                        formik.errors[ADD_SCHOOLS.EMAIL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.EMAIL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Phone Number")}</label>
                    {/* <Field
                    className="form_inputs"
                    placeholder={t("Phone Number")}
                    name={ADD_SCHOOLS.PHONE_NUMBER}
                  /> */}
                    <PhoneInput
                      inputProps={{
                        className: "",
                        name: `${ADD_SCHOOLS.PHONE_NUMBER}`,
                      }}
                      value={formik.values[ADD_SCHOOLS.PHONE_NUMBER]}
                      country={"ae"}
                      countryCodeEditable={false}
                      enableSearch={true}
                      onChange={(e) => {
                        formik.setFieldValue(ADD_SCHOOLS.PHONE_NUMBER, `+${e}`);
                        setTimeout(() => {
                          formik.validateField(ADD_SCHOOLS.PHONE_NUMBER);
                          setValidNumber(isValidPhoneNumber(`+${e}`));
                        }, 0);
                      }}
                    />
                    <div className="error-message-wrap">
                      {validNumber === false &&
                        formik.touched[ADD_SCHOOLS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(ADD_SCHOOLS_ERROR_MESSAGES.INVALID_PHONE_NUMBER)}
                        </div>
                      ) : null}
                      {formik.values[ADD_SCHOOLS.PHONE_NUMBER] == "" &&
                        validNumber === true &&
                        formik.touched[ADD_SCHOOLS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(ADD_SCHOOLS_ERROR_MESSAGES.PHONE_NUMBER_REQUIRED)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Weblink of School")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Weblink of School")}
                      name={ADD_SCHOOLS.WEBLINK_OF_SCHOOL}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.WEBLINK_OF_SCHOOL] &&
                        formik.errors[ADD_SCHOOLS.WEBLINK_OF_SCHOOL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.WEBLINK_OF_SCHOOL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Location")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Location")}
                      name={ADD_SCHOOLS.LOCATION}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.LOCATION] &&
                        formik.errors[ADD_SCHOOLS.LOCATION] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.LOCATION]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Fees Details")}</div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Tuition Fees")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Tuition Fees")}
                      name={ADD_SCHOOLS.TUITION_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.TUITION_FEES] &&
                        formik.errors[ADD_SCHOOLS.TUITION_FEES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.TUITION_FEES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Enrollment Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Enrollment Fees")}
                      name={ADD_SCHOOLS.ENROLLMENT_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.ENROLLMENT_FEES] &&
                        formik.errors[ADD_SCHOOLS.ENROLLMENT_FEES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.ENROLLMENT_FEES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Application Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Application Fees")}
                      name={ADD_SCHOOLS.APPLICATION_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.APPLICATION_FEES] &&
                        formik.errors[ADD_SCHOOLS.APPLICATION_FEES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.APPLICATION_FEES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Discount on Tuition Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("School Fees")}
                      name={ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES] &&
                        formik.errors[ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_SCHOOLS.DISCOUNT_ON_TUITION_FEES
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Optional Service Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Optional Service Fees")}
                      name={ADD_SCHOOLS.OPTIONAL_SERVICE_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.OPTIONAL_SERVICE_FEES] &&
                        formik.errors[ADD_SCHOOLS.OPTIONAL_SERVICE_FEES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_SCHOOLS.OPTIONAL_SERVICE_FEES]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Re-Enrollment Fees")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Re-Enrollment Fees")}
                      name={ADD_SCHOOLS.RE_ENROLLMENT_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.RE_ENROLLMENT_FEES] &&
                        formik.errors[ADD_SCHOOLS.RE_ENROLLMENT_FEES] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_SCHOOLS.RE_ENROLLMENT_FEES]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Total Fees")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Total Fees")}
                      name={ADD_SCHOOLS.TOTAL_FEES}
                      onInput={numberOnlyWithDecimal}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.TOTAL_FEES] &&
                        formik.errors[ADD_SCHOOLS.TOTAL_FEES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.TOTAL_FEES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Academic and Vacation Details")}</div>
              <div id="card-wrap">
                <div className="row">
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Start of the Academic Year")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("Start of the Academic Year")}
                          format="dd-MM-yyyy"
                          value={
                            new Date(
                              formik.values[
                              ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR
                              ]
                            )
                          }
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[
                          ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR
                        ] &&
                          formik.errors[
                          ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR
                          ] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[
                              ADD_SCHOOLS.START_OF_THE_ACADEMIC_YEAR
                              ]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("End of the Academic Year")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("End of the Academic Year")}
                          format="dd-MM-yyyy"
                          value={
                            new Date(
                              formik.values[
                              ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR
                              ]
                            )
                          }
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR] &&
                          formik.errors[ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[
                              ADD_SCHOOLS.END_OF_THE_ACADEMIC_YEAR
                              ]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Winter Break Start Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          className="date_pickers"
                          label={t("Winter Break Start Date")}
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.WINTER_BREAK_START_DATE]
                            )
                          }
                          format="dd-MM-yyyy"
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.WINTER_BREAK_START_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.WINTER_BREAK_START_DATE] &&
                          formik.errors[ADD_SCHOOLS.WINTER_BREAK_START_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[
                              ADD_SCHOOLS.WINTER_BREAK_START_DATE
                              ]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Winter Break End Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("Winter Break End Date")}
                          format="dd-MM-yyyy"
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.WINTER_BREAK_END_DATE]
                            )
                          }
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";

                            formik.setFieldValue(
                              ADD_SCHOOLS.WINTER_BREAK_END_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.WINTER_BREAK_END_DATE] &&
                          formik.errors[ADD_SCHOOLS.WINTER_BREAK_END_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[ADD_SCHOOLS.WINTER_BREAK_END_DATE]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Spring Break Start Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          className="date_pickers"
                          label={t("Spring Break Start Date")}
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.SPRING_BREAK_START_DATE]
                            )
                          }
                          format="dd-MM-yyyy"
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.SPRING_BREAK_START_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.SPRING_BREAK_START_DATE] &&
                          formik.errors[ADD_SCHOOLS.SPRING_BREAK_START_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[
                              ADD_SCHOOLS.SPRING_BREAK_START_DATE
                              ]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Spring Break End Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("Spring Break End Date")}
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.SPRING_BREAK_END_DATE]
                            )
                          }
                          format="dd-MM-yyyy"
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.SPRING_BREAK_END_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.SPRING_BREAK_END_DATE] &&
                          formik.errors[ADD_SCHOOLS.SPRING_BREAK_END_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[ADD_SCHOOLS.SPRING_BREAK_END_DATE]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Summer Break Start Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("Summer Break Start Date")}
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.SUMMER_BREAK_START_DATE]
                            )
                          }
                          format="dd-MM-yyyy"
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.SUMMER_BREAK_START_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        /* onChange={(date: any) =>
                      formik.setFieldValue(
                        ADD_SCHOOLS.SUMMER_BREAK_START_DATE,
                        date
                      )
                    } */
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.SUMMER_BREAK_START_DATE] &&
                          formik.errors[ADD_SCHOOLS.SUMMER_BREAK_START_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[
                              ADD_SCHOOLS.SUMMER_BREAK_START_DATE
                              ]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 acedemic_dates_container">
                    <div className="fields_label_wrapper">
                      <label className="fields_label">
                        {t("Summer Break End Date")}
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          className="date_pickers"
                          label={t("Summer Break End Date")}
                          value={
                            new Date(
                              formik.values[ADD_SCHOOLS.SUMMER_BREAK_END_DATE]
                            )
                          }
                          format="dd-MM-yyyy"
                          onChange={(date) => {
                            const formattedDate = date
                              ? format(date, COMMON_CONSTANTS.YMD_FORMAT)
                              : "";
                            formik.setFieldValue(
                              ADD_SCHOOLS.SUMMER_BREAK_END_DATE,
                              new Date(formattedDate)
                            );
                          }}
                        />
                      </LocalizationProvider>
                      <div className="error-message-wrap">
                        {formik.touched[ADD_SCHOOLS.SUMMER_BREAK_END_DATE] &&
                          formik.errors[ADD_SCHOOLS.SUMMER_BREAK_END_DATE] ? (
                          <div className="errorMessage">
                            {t(
                              `${formik.errors[ADD_SCHOOLS.SUMMER_BREAK_END_DATE]
                              }`
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row school-row-wrap">
              <div className="col-md-6">
                <div id="card-wrap">
                  <div id="holiday-card-title">{t("Holiday Count")}</div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Public Holidays")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Public Holidays")}
                      name={ADD_SCHOOLS.PUBLIC_HOLIDAYS}
                      onKeyPress={(event: any) => {
                        event.target.value.length <= 2
                          ? numberOnly(event)
                          : event.preventDefault();
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.PUBLIC_HOLIDAYS] &&
                        formik.errors[ADD_SCHOOLS.PUBLIC_HOLIDAYS] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.PUBLIC_HOLIDAYS]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Other Holidays")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Other Holidays")}
                      name={ADD_SCHOOLS.OTHER_HOLIDAYS}
                      onKeyPress={(event: any) => {
                        event.target.value.length <= 2
                          ? numberOnly(event)
                          : event.preventDefault();
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.OTHER_HOLIDAYS] &&
                        formik.errors[ADD_SCHOOLS.OTHER_HOLIDAYS] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.OTHER_HOLIDAYS]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div id="card-wrap">
                  <div id="holiday-card-title">{t("DSIB Report & Rating")}</div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("DSIB Inspection Report")}
                    </label>

                    <Field
                      disabled
                      className={
                        language === "English"
                          ? "form_inputs dsib-doc"
                          : "form_inputs dsib-doc-ar"
                      }
                      placeholder={t("DSIB Inspection Report")}
                      name={ADD_SCHOOLS.DSIB_INSPECTION_REPORT}
                      value={dsibDocName}
                    />
                    <input
                      className="image_input"
                      type="file"
                      accept=""
                      onChange={onUploadDsibRecord}
                      ref={dsibDocs}
                    />
                    {dsibDocName != "" && (
                      <img
                        src={eyeIcon}
                        alt="Learn and Play"
                        className={
                          language === "English"
                            ? "dsib-eye-icon"
                            : "dsib-eye-icon-ar"
                        }
                        onClick={() => {
                          window.open(dsibDoc);
                        }}
                      />
                    )}
                    <img
                      src={uploadFile}
                      alt="Learn and Play"
                      className={
                        language === "English"
                          ? "dsib-upload-icon"
                          : "dsib-upload-icon-ar"
                      }
                      onClick={() => dsibDocs.current?.click()}
                    />

                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.DSIB_INSPECTION_REPORT] &&
                        formik.errors[ADD_SCHOOLS.DSIB_INSPECTION_REPORT] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_SCHOOLS.DSIB_INSPECTION_REPORT]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("DSIB Rating")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("DSIB Rating")}
                      name={ADD_SCHOOLS.DSIB_RATING}
                      as="select"
                    >
                      <option hidden value="default">
                        {t("--Please select--")}
                      </option>
                      <option value="Outstanding">Outstanding</option>
                      <option value="VeryGood">Very Good</option>
                      <option value="Good">Good</option>
                      <option value="Acceptable">Acceptable</option>
                      <option value="Weak">Weak</option>
                      <option value="VeryWeak">Very Weak</option>
                      <option value="NotApplicable">Not Applicable</option>
                    </Field>
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.DSIB_RATING] &&
                        formik.errors[ADD_SCHOOLS.DSIB_RATING] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.DSIB_RATING]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div className="col-md-12">
                <div className="fields_label_wrapper">
                  {/* <label className="fields_label">{t("School Images")}</label> */}
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg,.mov,.mp4,.mkv"
                    multiple
                    onChange={handleChange}
                    ref={uploadSchoolImages}
                  />
                  <div className="add_images_wrapper">
                    <div
                      className="add_images_cotainer"
                      onClick={() => uploadSchoolImages.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                  </div>

                  <div className="error-message-wrap">
                    {formik.touched[ADD_SCHOOLS.SCHOOL_IMAGES] &&
                      formik.errors[ADD_SCHOOLS.SCHOOL_IMAGES] ? (
                      <div className="errorMessage">
                        {t(`${formik.errors[ADD_SCHOOLS.SCHOOL_IMAGES]}`)}
                      </div>
                    ) : null}
                  </div>
                </div>
                {schoolImages.length > 0 && (
                  <div className="image-array-wrap">
                    {schoolImages.map((image: any, index: any) => {
                      return (
                        <div className="image-wrap" key={index}>
                          <img
                            src={image}
                            key={index}
                            className="schoolimage-list"
                            alt="Learn and Play"
                          />
                          <img
                            className="cancel-icon"
                            onClick={handleDelete(index)}
                            src={close}
                            alt="Learn and Play"
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="actions_button_container">
              <button
                className="cancel_button"
                onClick={() => {
                  navigate("/manage-schools");
                }}
              >
                {t("Cancel")}
              </button>
              <button
                className="update_button"
                type="submit"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                {t("Update")}
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default EditSchools;
